import { SchedulingGridViewStateHost } from '../schema/SchedulingGridViewState';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { OwaDate } from 'owa-datetime';
import { action } from 'satcheljs';

/**
 * Initializes the scheduling grid.
 *
 * The selectedTime should be initialized with Start and End dates in the respective time zones.
 * The scheduling grid will then display time in the Start time zone.
 * It will also show the two time zone headers if the Start and End time zones are different.
 */
export const initializeSchedulingGrid = action(
    'schedulingGrid-initializeSchedulingGrid',
    (
        viewStateHost: SchedulingGridViewStateHost,
        folderIds: string[],
        selectedDate: OwaDate,
        selectedTime: CalendarEvent,
        filterItemsFunction: (items: CalendarEvent[]) => CalendarEvent[]
    ) => ({
        viewStateHost,
        folderIds,
        selectedDate,
        selectedTime,
        filterItemsFunction,
    })
);

/**
 * Refreshes the scheduling grid.
 *
 * Useful for controlled scenarios where a consumer wishes to re-render the grid with latest calendar
 * data from the cache based on some externally-subscribed action.
 *
 * TODO VSO 46548 investigate exposing controlled and uncontrolled versions of scheduling grid
 */
export const refreshSchedulingGrid = action(
    'schedulingGrid-refreshSchedulingGrid',
    (viewStateHost: SchedulingGridViewStateHost) => ({ viewStateHost })
);

export const resetSchedulingGrid = action(
    'schedulingGrid-resetSchedulingGrid',
    (viewStateHost: SchedulingGridViewStateHost, eventsCacheLockId: any) => ({
        viewStateHost: viewStateHost,
        eventsCacheLockId: eventsCacheLockId,
    })
);

export const updateFolderIds = action(
    'schedulingGrid-updateFolderIds',
    (viewStateHost: SchedulingGridViewStateHost, folderIds: string[]) => ({
        viewStateHost: viewStateHost,
        folderIds: folderIds,
    })
);

export const navigateToDate = action(
    'schedulingGrid-navigateToDate',
    (viewStateHost: SchedulingGridViewStateHost, newDate: OwaDate) => ({
        viewStateHost,
        newDate,
    })
);

export const updateSelectionItem = action(
    'schedulingGrid-updateSelectionItem',
    (viewStateHost: SchedulingGridViewStateHost, selectionItem: CalendarEvent) => ({
        viewStateHost: viewStateHost,
        selectionItem: selectionItem,
    })
);
